import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMemberInvitationLinkValidityKey } from '../../utils/keys';
export const useValidateLink = (options) => {
    const { useQueryOptions, variables } = options || {};
    const { client } = useTribeClient();
    const memberInvitationLinkValidityKey = getMemberInvitationLinkValidityKey({
        variables,
    });
    return useQuery(memberInvitationLinkValidityKey, () => client.invitations.validateLink(variables), useQueryOptions);
};
//# sourceMappingURL=useValidateLink.js.map